import { useError } from "../../context/useErrorContext"
import { GetRequest } from "../../services/ApiClientService"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { ERequestType } from "../../Enum/ERequestType"
import { useTranslation } from "react-i18next"

export interface AdminEmployeeProfile {
  adminEmployeeId: number
  name: string
  isRoot: boolean
  permissions: string[]
}

export const useGetAdminEmployeeProfile = () => {
  const { t } = useTranslation("general")

  const { setError } = useError()

  const handleGetAdminEmployeeProfile = async (onSuccess: (profile: AdminEmployeeProfile) => void) => {
    try {
      const response = await GetRequest<AdminEmployeeProfile>(API_ROUTES.ADMIN_EMPLOYEE.ME, ERequestType.Admin)

      if (response.success && response.data) {
        onSuccess(response.data)

        return
      }

      throw new Error(response.message)
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")

      setError(t("label_title_erro"), message)
    }
  }

  return { handleGetAdminEmployeeProfile }
}
